import { Link, useViewTransitionState } from 'react-router'
import type { ElementType, ReactNode } from 'react'

import './system.css'

function CardLink({
  to,
  className,
  children,
}: {
  to: string
  className: string
  children: ReactNode
}) {
  const opening = useViewTransitionState(to)

  return (
    <Link
      className={className}
      to={to}
      viewTransition
      style={opening ? { viewTransitionName: 'detail' } : undefined}
    >
      {children}
    </Link>
  )
}

export function Card({
  as: As = 'div',
  to,
  rail = false,
  flat = false,
  inverse = false,
  solid = false,
  className,
  children,
}: {
  as?: ElementType
  to?: string | undefined
  rail?: boolean
  flat?: boolean
  inverse?: boolean
  solid?: boolean
  className?: string
  children: ReactNode
}) {
  const classes = ['card']

  if (rail) {
    classes.push('card--rail')
  }

  if (flat) {
    classes.push('card--flat')
  }

  if (inverse) {
    classes.push('card--inverse')
  }

  if (solid) {
    classes.push('card--solid')
  }

  if (className) {
    classes.push(className)
  }

  if (to) {
    return (
      <CardLink to={to} className={classes.join(' ')}>
        {children}
      </CardLink>
    )
  }

  return <As className={classes.join(' ')}>{children}</As>
}
